module.exports = __webpack_public_path__ + "media/img/uploads/press-news-thumb-02-db6bc42cd11dd79ef2aa8fde26f7f440.jpg";